import React, {FC, useEffect, useRef, useState} from "react";
import cls from "../../../atoms/atoms.module.scss";
import {CustomSelectArrow} from "../../../svg";
import {PropsFields} from "../../../atoms/customFields/types";

export interface IDropDown extends PropsFields {
    item: any,
    handleChange: (value: string) => void
}


const CustomDropdown: FC<IDropDown> = (
    {
        item: {
            attribute_code,
            default_label,
            field_options
        },
        handleChange,
    }
) => {
    const [open, setOpen] = useState<boolean>(false)
    const rootRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleEvent = (e: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleEvent)
        return () => document.removeEventListener('mousedown', handleEvent)
    }, [])

    const handleClick = (selectedLabel: string) => {
        handleChange(selectedLabel as any)
        setOpen(false)
    }

    const displayDropDown = {
        "true": "block",
        "false": "none"
    }
    const openDropDown = {
        "true": cls.drop_down_opened,
        "false": ""
    }

    return (
        <div className={cls.drop_down} ref={rootRef}>
            <div className={cls.drop_down_btn} onClick={() => setOpen(prevState => !prevState)}>
                {attribute_code}{" "}{default_label}
                <CustomSelectArrow className={`${cls.drop_down_arrow} ${openDropDown[`${open}`]}`}/>
            </div>
            <div style={{display: displayDropDown[`${open}`]}} className={cls.drop_down_block}>
                {field_options.map((option: any, index: number) => {
                    return (
                        <div key={index}
                             id={String(option.id)}
                             className={cls.drop_down_option}
                             onClick={() => handleClick(option.key)}
                        >
                            {option.label}
                        </div>
                    );
                })}
            </div>
        </div>
    )
};

export default CustomDropdown;